import type React from 'react';
import cx from 'clsx';
import Styles from './ConstructionList.module.scss';
import { toThousandSeparator } from '~/utils/CurrencySeparator';
import type { DealConstructionContext } from '~/models/DealConstruction';
import { isDealBillingContext } from '~/models/DealConstruction';

type Props = {
  constructionContext: DealConstructionContext;
  showSwitchEnable: boolean;
  showButtons: boolean;
  target: 'owner' | 'rentee' | null;
  companyType: 'client' | 'vendor' | 'partner';
  docType: 'billing' | 'estimation';
  showEstimationConfirmedButton?: boolean;
};

export const ConstructionListFooterRow: React.FC<Props> = ({
  constructionContext,
  showSwitchEnable,
  showButtons,
  target,
  companyType,
  docType,
  showEstimationConfirmedButton = false
}: Props) => {
  const { totalAmount, totalAmountWithTax } = constructionContext;
  const isClientEstimation =
    companyType === 'client' && docType === 'estimation';
  return (
    <tr
      className={
        showEstimationConfirmedButton
          ? cx(Styles.ListRow, Styles.TwoTierFooter)
          : cx(Styles.ListRow, Styles.Footer)
      }
    >
      <td className={Styles.OrderHandle} />
      {showSwitchEnable && <td className={Styles.SwitchEnable} />}
      <td className={Styles.Estimation}>
        <div className={isClientEstimation ? Styles.SumPoint : Styles.Point}>
          {docType === 'estimation' ? '合計' : '施工項目合計'}
        </div>
        {isClientEstimation && (
          <span className={Styles.TaxAnnotate}>
            課税方法の変更に伴う、イタンジ請求書金額とのずれについては
            <a
              className={Styles.TaxChangeLink}
              href="https://naiso-kojikun.zendesk.com/hc/ja/articles/17488949382163"
              rel="noreferrer"
              target="_blank"
            >
              こちら
            </a>
          </span>
        )}
      </td>
      <td className={Styles.UnitAmount} />
      <td className={Styles.ChargePer} />
      {target !== null && (
        <td className={Styles.ForAmount}>
          {target === 'rentee' && isDealBillingContext(constructionContext) && (
            <div>
              ¥{toThousandSeparator(constructionContext.sumRenteeAmountWithTax)}
              <div className={Styles.WithoutTax}>
                税抜：¥
                {toThousandSeparator(constructionContext.sumRenteeAmount)}
              </div>
            </div>
          )}
          {target === 'owner' && isDealBillingContext(constructionContext) && (
            <div>
              ¥{toThousandSeparator(constructionContext.sumOwnerAmountWithTax)}
              <div className={Styles.WithoutTax}>
                税抜：¥{toThousandSeparator(constructionContext.sumOwnerAmount)}
              </div>
            </div>
          )}
        </td>
      )}
      <td className={Styles.Amount}>
        ¥{toThousandSeparator(totalAmountWithTax)}
        <div className={Styles.WithoutTax}>
          税抜：¥{toThousandSeparator(totalAmount)}
        </div>
      </td>
      {showButtons && <td className={Styles.Buttons} />}
    </tr>
  );
};
